module.exports = __webpack_public_path__ + "src/components/buttons/checkmark.svg";